import React, { useEffect, useState } from 'react';
import { Typography, Button, makeStyles, Box, Container, Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import GoogleSheetsService from '../services/GoogleSheetsService';
import { Link } from 'react-router-dom';
import SimpleAccordion from '../component/SimpleAccordion';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#fff',

    },
    title1: {
        fontSize: '2.5rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#00095b !important'
    },
    gridParent: {
        display: 'flex',
        alignItems: 'center'
    },
    box0: {
        marginBottom: theme.spacing(6)
    },
    box1: {
        marginTop: theme.spacing(1)
    },
    boxList: {
        marginTop: theme.spacing(6)
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    button: {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
        [theme.breakpoints.up('md')]: {
            marginTop: theme.spacing(2),
        },
    },
    imageWeb: {
        display: 'block',
        width: '100%',
        height: '100%', // Ảnh lấp đầy container
        objectFit: 'cover',  // Đảm bảo ảnh không bị méo
        borderRadius: '10px'
    },
    contentChild: {
        padding: theme.spacing(1),
        marginTop: theme.spacing(4),
    },
    button61: {
        borderColor: '#1976d2',
        color: '#1976d2',
        '&:hover': {
            backgroundColor: '#1565c0',
            color: '#fff',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    },
}));



const ChiTietXe = () => {
    const classes = useStyles();
    const { product } = useParams();
    const { name } = useParams();

    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async (sheetName) => {
            console.log(sheetName);
            try {
                const data = await GoogleSheetsService.getData(sheetName, 'A:I');
                const fordData = data.find(item => item.tenLink === name);
                setData(fordData)
            } catch (err) {
            }
        };

        fetchData(product);
    }, []);


    const componentMap = {
        'ford-territory-titanium-x': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium-x/cards/territory-titanium-front-grille-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Diện mạo mới thêm phong cách
                            </Typography>
                            <Typography variant="body6">
                               Mặt ca lăng lớn, thiết kế mới mang đến dáng vẻ đầy cá tính, hiện đại đậm chất Ford.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium-x/cards/territory-titanium-led-headlamp-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Đèn pha LED đặc trưng
                            </Typography>
                            <Typography variant="body6">
                                Kết hợp với dải đèn LED ban ngày tạo nên tổng thể hiện đại và hiệu quả chiếu sáng tối ưu.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium-x/cards/territory-titanium-digital-mirror-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Gương chiếu hậu kỹ thuật số tiên phong trong phân khúc
                            </Typography>
                            <Typography variant="body6">
                                Camera 2 megapixel thu hình ảnh phía sau xe và truyền video trực tiếp lên gương chiếu hậu kỹ thuật số.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium-x/cards/territory-titanium-taillamp-4.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Thiết kế đuôi xe ấn tượng
                            </Typography>
                            <Typography variant="body6">
                                Cụm đèn hậu với dải đèn LED tạo thành điểm nhấn cho phần đuôi xe thu hút mọi ánh nhìn.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium-x/cards/territory-titanium-panoramic-sunroof-5.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Cửa sổ trời toàn cảnh
                            </Typography>
                            <Typography variant="body6">
                                Mở ra mở ra cả thế giới và trải nghiệm cuộc sống, khiến cho hành trình trở nên thú vị cho mọi thành viên trên xe.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium-x/cards/territory-titanium-ambient-light-6.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất rộng rãi vượt trội
                            </Typography>
                            <Typography variant="body6">
                                Không gian bên trong xe thoải mái, tiện nghi với điểm nhấn đèn trang trí nội thất đa sắc màu và ghế da cao cấp.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-territory-sport': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/sport/cards/territory-sport-card-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Lưới tản nhiệt sơn đen thể thao
                            </Typography>
                            <Typography variant="body6">
                                Những điểm nhấn màu đen hiện đại kết hợp với lưới tản nhiệt phía trước màu đen tạo nên vẻ ngoài thể thao ấn tượng
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/sport/cards/territory-sport-card-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                La-zăng hợp kim sơn đen 18’’
                            </Typography>
                            <Typography variant="body6">
                                La-zăng hợp kim 18’’ màu đen bật lên vẻ cá tính và sang trọng của Territory Sport.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/sport/cards/territory-sport-card-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất mới với nhiều điểm nhấn cá tính
                            </Typography>
                            <Typography variant="body6">
                                Ghế bọc da sang trọng với điểm nhấn là những chi tiết màu trắng và cam trẻ trung, cá tính, tạo nên phong cách ấn tượng cho chủ sở hữu của chiếc xe.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/sport/cards/territory-sport-card-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Công nghệ tiên tiến
                            </Typography>
                            <Typography variant="body6">
                                Ford Territory Sport được trang bị cụm đồng hồ kỹ thuật số 7 inch tích hợp cùng màn hình cảm ứng 12 inch, và một loạt các tính năng hỗ trợ người lái như Kiểm soát hành trình thích ứng1, Hệ thống cảnh báo điểm mù kết hợp Cảnh báo xe cắt ngang, Hệ thống Cảnh báo lệch làn đường¹ và Camera 360 độ.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/sport/cards/territory-sport-card-5.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Cần số điện tử với tấm ốp họa tiết carbon
                            </Typography>
                            <Typography variant="body6">
                                Trải nghiệm sự sang trọng và tinh tế với nội thất sợi carbon độc đáo trên phiên bản Sport, nâng tầm thiết kế giúp chiếc xe thêm phần hiện đại.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/sport/cards/territory-sport-card-6.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Hàng ghế thứ hai rộng rãi
                            </Typography>
                            <Typography variant="body6">
                                Thiết kế không gian hàng ghế thứ hai rộng rãi tinh tế, tập trung vào sự thoải mái, mang đến cho bạn khoảng để chân lý tưởng, biến mọi chuyến đi thành một trải nghiệm thú vị.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-territory-titanium': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium/cards/feature-card-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất rộng rãi, thoải mái
                            </Typography>
                            <Typography variant="body6">
                                Ghế bọc da sang trọng, không gian rộng rãi. Ford Territory mới mang đến cảm giác thoải mái, êm ái suốt hành trình.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium/cards/feature-card-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Màn hình trung tâm cảm ứng 12.3″
                            </Typography>
                            <Typography variant="body6">
                                Màn hình trung tâm 12.3″ với giao diện tiếng Việt cùng nhiều chức năng hiện đại giúp bạn dễ dàng kiểm soát các chức năng trên xe và tạo ra không gian giải trí đầy sôi động cho chủ nhân của chiếc xe và các thành viên trong gia đình trên mọi hành trình.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium/cards/feature-card-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Khoang hành lý rộng rãi, tiện lợi
                            </Typography>
                            <Typography variant="body6">
                                Với không gian chứa đồ rộng rãi, phù hợp cho cả những chuyến đi dài ngày. Thiết kế thông minh giúp xếp dỡ hành lý dễ dàng và tối ưu không gian chứa đồ.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/titanium/cards/feature-card-4.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                An toàn hàng đầu
                            </Typography>
                            <Typography variant="body6">
                                Ford Territory Mới mang lại sự an toàn tối đa cho cả gia đình với những tính năng an toàn hàng đầu: hệ thống kiểm soát hành trình, hệ thống cảnh báo lệch làn đường, cảnh báo điểm mù...
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-territory-trend': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/trend/cards/trend-card-1-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất rộng rãi, thoải mái
                            </Typography>
                            <Typography variant="body6">
                                Ghế bọc da sang trọng, không gian rộng rãi. Ford Territory mới mang đến cảm giác thoải mái, êm ái suốt hành trìnhạo, tiên phong trong triết lý thiết kế mới của Ford.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/trend/cards/trend-card-1-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Ứng dụng FordPass thông minh
                            </Typography>
                            <Typography variant="body6">
                                Nâng tầm trải nghiệm với ứng dụng di động FordPass - kết nối bạn với chiếc Ford Territory của mình. Nhờ FordPass Connect Modem tích hợp, bạn có thể dễ dàng khóa/mở khóa, khởi động xe từ xa, kiểm tra tình trạng sức khỏe của xe và định vị chính xác vị trí của xe mọi lúc, mọi nơi.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/trend/cards/trend-card-2-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Kết nối không dây không giới hạn
                            </Typography>
                            <Typography variant="body6">
                                Dễ dàng kết nối và điều khiển điện thoại thông minh bằng màn hình cảm ứng trung tâm 12″ thông qua Apple CarPlayTM & Android AutoTM.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/model/trend/cards/trend-card-2-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Sạc không dây tiện dụng
                            </Typography>
                            <Typography variant="body6">
                                Liên tục kết nối không giới hạn với bạn bè và các ứng dụng thông minh mà không cần lo lắng điện thoại hết pin.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-everest-platinum': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/platinum/cards/c-clamp-headlamp.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Ngoại thất mang đậm chất DNA Ford
                            </Typography>
                            <Typography variant="body6">
                                Thiết kế lưới tản nhiệt mới thêm nổi bật với những chi tiết mạ chrome cao cấp, cho một ngoại thất tinh tế và sang trọng. Nắp ca-pô với đường dập nổi độc đáo cùng hàng chữ “Platinum” 3D khẳng định vị thế của chiếc xe.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/platinum/cards/20-inch-alloy-wheels.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Vành hợp kim 20 inch
                            </Typography>
                            <Typography variant="body6">
                                Vành xe hợp kim 20 inch, 12 chấu với 3 lớp sơn càng làm tôn thêm dáng vẻ bề thế và sang trọng của chiếc xe ở mọi góc nhìn.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/platinum/cards/modern-control-panel.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng điều khiển hiện đại
                            </Typography>
                            <Typography variant="body6">
                                Bảng điều khiển trung tâm thiết kế trải dài sang hai bên cho cảm giác khoang xe được mở rộng hơn. Phiên bản Platinum được trang bị màn hình đồng hồ kỹ thuật số 12,4 inch và màn hình giải trí LCD cảm ứng 12 inch.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/platinum/cards/luxury-interior.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất đẳng cấp
                            </Typography>
                            <Typography variant="body6">
                                Hàng ghế ngồi phía trước được trang bị sưởi điện và thông gió, điều chỉnh điện 10 hướng, nhớ vị trí chỉnh ghế. Nội thất sử dụng chất liệu da cao cấp, lòng ghế thiết kế trần trám cùng với logo Platinum thương hiệu tạo nên sự sang trọng cho chiếc xe. Cửa sổ trời toàn cảnh như mang cả thế giới bên ngoài vào trong xe.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/platinum/cards/b-and-o-speaker.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Hệ thống loa high-end
                            </Typography>
                            <Typography variant="body6">
                                Hệ thống loa B&O cho trải nghiệm âm thanh tuyệt vời với chất âm trung thực và rõ ràng đến từng chi tiết.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/platinum/cards/zone-lighting.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Hệ thống chiếu sáng đa vùng
                            </Typography>
                            <Typography variant="body6">
                                Hệ thống đèn chiếu sáng trên Everest có thể bật/tắt toàn vùng hay độc lập từng vùng cho phép người lái xe linh hoạt điều chỉnh đèn chiếu sáng theo nhu cầu và điều kiện cụ thể.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-everest-titanium': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nâng Tầm Thiết Kế
                            </Typography>
                            <Typography variant="body6">
                                hần đầu xe Everest Titanium đặc biệt nổi bật với lưới tản nhiệt dạng lưới mạ crôm kết hợp cùng cụm đèn LED hình chữ C mang đậm đặc trưng thiết kế toàn cầu của Ford. Các điểm nhấn mạ crôm trên gương, tay nắm cửa, bậc lên xuống hai bên xe tạo nên vẻ cứng cáp nhưng vẫn vô cùng sang trọng cho chiếc xe.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Mâm Xe Hợp Kim với thiết kế hiện đại
                            </Typography>
                            <Typography variant="body6">
                                Mâm xe hợp kim lớn 20 inch đa chấu đươc hoàn thiện tỉ mỉ, tôn thêm vẻ bề thế, cơ bắp và linh hoạt cho Titanium. Các điểm nhấn mạ chrôm trên tấm chắn bùn giúp gắn kết bánh xe với phần thân trên.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng Điều Khiển Kỹ thuật số Cao Cấp
                            </Typography>
                            <Typography variant="body6">
                                Bảng điều khiển mới với thiết kế trải rộng tạo một không gian vô cùng rộng rãi cho khoang lái. Xung quanh cụm đồng hồ kỹ thuật số và màn hình cảm ứng LCD 12 inch tích hợp là những chi tiết hoàn thiện tinh xảo với chất liệu cao cấp.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-4.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội Thất Đặc trưng hoàn thiện
                            </Typography>
                            <Typography variant="body6">
                                Nội thất màu đen gỗ mun và nâu hạt dẻ tùy chọn, ghế bọc da sang trọng, êm ái với cấu tạo lỗ đệm thông khí. Các chi tiết trên xe bằng kim loại được mài và đánh bóng bề mặt để tạo cảm giác sang trọng mỗi khi bạn chạm tay. Cửa số trời Toàn cảnh mở rộng tầm nhìn của bạn và mang đến không gian mở phóng khoáng.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-5.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Chế độ Lái tùy chọn
                            </Typography>
                            <Typography variant="body6">
                                Everest cho phép bạn lựa chọn một trong sáu chế độ lái trên đường bằng hay địa hình, sẵn sàng làm chủ mọi cung đường. Dù bạn đi đâu, làm gì, chỉ cần một nút xoay là bạn sẽ dễ dàng vượt qua những địa hình khó khăn nhất.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-6.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Gài cầu điện tử Everest
                            </Typography>
                            <Typography variant="body6">
                                Thế hệ Mới được trang bị tính năng Gài cầu điện tử 4x4 ‘Shift on the Fly’, cho phép bạn chuyển từ 1 cầu sang 2 cầu ngay cả khi xe đang chạy, đem lại trải nghiệm lái off-road tuyệt vời.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-everest-titanium20': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nâng Tầm Thiết Kế
                            </Typography>
                            <Typography variant="body6">
                                hần đầu xe Everest Titanium đặc biệt nổi bật với lưới tản nhiệt dạng lưới mạ crôm kết hợp cùng cụm đèn LED hình chữ C mang đậm đặc trưng thiết kế toàn cầu của Ford. Các điểm nhấn mạ crôm trên gương, tay nắm cửa, bậc lên xuống hai bên xe tạo nên vẻ cứng cáp nhưng vẫn vô cùng sang trọng cho chiếc xe.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Mâm Xe Hợp Kim với thiết kế hiện đại
                            </Typography>
                            <Typography variant="body6">
                                Mâm xe hợp kim lớn 20 inch đa chấu đươc hoàn thiện tỉ mỉ, tôn thêm vẻ bề thế, cơ bắp và linh hoạt cho Titanium. Các điểm nhấn mạ chrôm trên tấm chắn bùn giúp gắn kết bánh xe với phần thân trên.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng Điều Khiển Kỹ thuật số Cao Cấp
                            </Typography>
                            <Typography variant="body6">
                                Bảng điều khiển mới với thiết kế trải rộng tạo một không gian vô cùng rộng rãi cho khoang lái. Xung quanh cụm đồng hồ kỹ thuật số và màn hình cảm ứng LCD 12 inch tích hợp là những chi tiết hoàn thiện tinh xảo với chất liệu cao cấp.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-4.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội Thất Đặc trưng hoàn thiện
                            </Typography>
                            <Typography variant="body6">
                                Nội thất màu đen gỗ mun và nâu hạt dẻ tùy chọn, ghế bọc da sang trọng, êm ái với cấu tạo lỗ đệm thông khí. Các chi tiết trên xe bằng kim loại được mài và đánh bóng bề mặt để tạo cảm giác sang trọng mỗi khi bạn chạm tay. Cửa số trời Toàn cảnh mở rộng tầm nhìn của bạn và mang đến không gian mở phóng khoáng.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-5.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Chế độ Lái tùy chọn
                            </Typography>
                            <Typography variant="body6">
                                Everest cho phép bạn lựa chọn một trong sáu chế độ lái trên đường bằng hay địa hình, sẵn sàng làm chủ mọi cung đường. Dù bạn đi đâu, làm gì, chỉ cần một nút xoay là bạn sẽ dễ dàng vượt qua những địa hình khó khăn nhất.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/titanium/cards/everest-titanium-col-6.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Gài cầu điện tử Everest
                            </Typography>
                            <Typography variant="body6">
                                Thế hệ Mới được trang bị tính năng Gài cầu điện tử 4x4 ‘Shift on the Fly’, cho phép bạn chuyển từ 1 cầu sang 2 cầu ngay cả khi xe đang chạy, đem lại trải nghiệm lái off-road tuyệt vời.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-everest-sport': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/sport/cards/bold-black-design-col-01.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Thiết kế đen táo bạo
                            </Typography>
                            <Typography variant="body6">
                                Lưới tản nhiệt, tấm che gầm và ốp bậc lên xuống đều được sơn đen mang đến cho Sport vẻ ngoài ấn tượng và đậm chất thể thao.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/sport/cards/glossy-black-alloy-wheels-col-02.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Mâm Xe Hợp kim Đen bóng
                            </Typography>
                            <Typography variant="body6">
                                Mâm xe hợp kim 20 inch đen bóng vừa tôn thêm dáng vẻ thể thao cho Everest Sport, vừa kết hợp hoàn hảo với các điểm nhấn màu đen phía trước và sau xe.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/sport/cards/advanced-digital-control-panel-col-03.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng Điều khiển Kỹ thuật số Cao cấp
                            </Typography>
                            <Typography variant="body6">
                                Bảng điều khiển mới với thiết kế trải rộng tạo một không gian vô cùng rộng rãi cho khoang lái. Xung quanh cụm đồng hồ kỹ thuật số và màn hình giải trí cảm ứng LCD 10,1 inch tích hợp là những chi tiết hoàn thiện tinh xảo với chất liệu cao cấp.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/sport/cards/luxurious-black-interior-col-04.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất đen sang trọng
                            </Typography>
                            <Typography variant="body6">
                                Nội thất màu đen gỗ mun sang trọng kết hợp cùng các chi tiết kim loại sáng bóng tạo nên nét tương phản nổi bật bên trong Everest Sport. Ghế đệm êm ái cho bạn cảm giác thoải mái tối đa trên mọi hành trình.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-everest-ambiente': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/ambiente/cards/everest-ambiente-front-grille.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Lưới Tản nhiệt Đặc trưng
                            </Typography>
                            <Typography variant="body6">
                                Một thanh đơn nằm ngang chắc chắn tạo nên dáng vẻ hầm hố cho phiên bản Ambiente. Điểm nhấn cho tấm lưới tản nhiệt thiết kế mới chính là cụm đèn LED hình chữ C, mang phong đặc trưng của ‘Built Ford Tough’.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/ambiente/cards/everest-ambiente-wheels.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Mâm xe Hợp kim 18 inch
                            </Typography>
                            <Typography variant="body6">
                                Mâm xe hợp kim 18 inch màu đen bạc ánh kim làm tôn lên vẻ tự tin và chắc chắn cho Everest Ambiente.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/ambiente/cards/everest-ambiente-front-console.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng Điều khiển Kỹ thuật số Cao cấp
                            </Typography>
                            <Typography variant="body6">
                                Bảng điều khiển mới với thiết kế trải rộng tạo một không gian vô cùng rộng rãi cho khoang lái. Xung quanh cụm đồng hồ kỹ thuật số và màn hình cảm ứng LCD 10,1 inch tích hợp là những chi tiết hoàn thiện tinh xảo với chất liệu cao cấp.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/everest/model/ambiente/cards/everest-ambiente-passengers-seat.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nâng tầm Tiện nghi
                            </Typography>
                            <Typography variant="body6">
                                Thiết kế ghế ngồi hoàn toàn mới với lớp đệm và mút xốp giúp tối ưu sự thoải mái. Chất liệu và độ hoàn thiện giúp nâng tầm toàn bộ không gian khoang lái của Ambiente. Hệ thống treo được tinh chỉnh mang đến trải nghiệm lái tốt hơn trên cả đường bằng và đường off-road.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-ranger-raptor': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/raptor/cards/raptor-col-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Thiết kế đầu xe đặc trưng
                            </Typography>
                            <Typography variant="body6">
                                Điểm nhấn then chốt phần đầu xe là chữ Ford được thiết kế dạng khối nổi cỡ lớn. Đèn LED ma trận nổi bật trong đêm, cản trước bắt thẳng vào khung xe và tấm hợp kim chắn gầm siêu cứng, tất cả đều như đang sẵn sàng mở đường dẫn lối.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/raptor/cards/raptor-col-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                La-zăng hợp kim địa hình
                            </Typography>
                            <Typography variant="body6">
                                Bộ la-zăng hợp kim 17 inch hầm hố dành cho đường địa hình lắp với lốp xe BF GoodRich All-Terrain K02 hiệu năng cao danh tiếng (kích thước 285/70 R17). Dù vượt núi đồi hay chạy tốc độ cao, đều đáp ứng trong mọi điều kiện.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/raptor/cards/raptor-col-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng đồng hồ điều khiển độc đáo
                            </Typography>
                            <Typography variant="body6">
                                Cụm màn hình kỹ thuật số 12,4 inch hiển thị đầy đủ cấu hình xe, nằm trên bảng táp lô thiết kế liền mạch trải rộng, cùng với màn hình giải trí cảm ứng trung tâm 12 inch.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/raptor/cards/raptor-col-4.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Ghế ngồi theo phong cách thiết kế Ford Performance
                            </Typography>
                            <Typography variant="body6">
                                Lấy cảm hứng từ máy bay chiến đấu phản lực, ghế ngồi xe Raptor có thiết kế ôm trọn người lái, giúp lái xe có tư thế chắc chắn khi ôm cua hoặc tiếp đất. Các đường chỉ khâu độc đáo và kết hợp với da lộn giúp tối ưu sự thoải mái và tăng tính thẩm mỹ.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-ranger-stormtrak': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/stormtrak/stormtrak-col-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Lưới tản nhiệt thiết kế độc đáo
                            </Typography>
                            <Typography variant="body6">
                                Kết hợp cùng hệ thống đèn pha LED Matrix và dải đèn trợ sáng hai bên, lưới tản nhiệt thiết kế mới tăng thêm sự mạnh mẽ và cá tính cho Ford Ranger Stormtrak.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/stormtrak/stormtrak-col-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Vành thể thao ấn tượng
                            </Typography>
                            <Typography variant="body6">
                                Bộ vành hợp kim 20 inch đen tuyền cùng điểm nhấn kết hợp màu đỏ và đen đặc trưng cho dáng vẻ thể thao hơn.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/stormtrak/stormtrak-col-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Hệ thống giá đỡ đa năng
                            </Typography>
                            <Typography variant="body6">
                                Chở hàng hóa trên thùng xe phía sau sẽ dễ dàng và chắc chắn hơn rất nhiều nhờ hệ thống giá nóc và thanh thể thao đa năng và di chuyển linh hoạt, phù hợp với nhiều kích cỡ chở đồ.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/stormtrak/stormtrak-col-4.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Camera 360°
                            </Typography>
                            <Typography variant="body6">
                                Cho phép bạn dễ dàng quan sát xung quanh xe, bao gồm chế độ xem 360° từ trên xuống hay 180° từ trước ra sau. Tính năng này rất hữu dụng khi bạn đi vào con đường hẹp hay lái xe trong điều kiện off-road.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/stormtrak/stormtrak-col-5.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Thiết kế nội thất riêng biệt
                            </Typography>
                            <Typography variant="body6">
                                Nội thất Ranger Stormtrak mang thiết kế đặc trưng với tông màu đen kết hợp với đường chỉ đỏ tương phản, đặc biệt ghế da được thêu chữ “Stormtrak” màu đỏ cùng những công nghệ hiện đại trang bị trên xe giúp đáp ứng mọi nhu cầu của người lái.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/stormtrak/stormtrak-col-6.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Cần số Điện tử
                            </Typography>
                            <Typography variant="body6">
                                Công nghệ lái Thế Hệ Mới được ứng dụng trên Ranger Stormtrak giúp bạn lái xe an toàn hơn và luôn tự tin kiểm soát chiếc xe của mình với tính năng Cần số Điện tử.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-ranger-wildtrak': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/wildtrak/wildtrak-col-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Lưới tản nhiệt độc đáo
                            </Typography>
                            <Typography variant="body6">
                                Lưới tản nhiệt của Ranger có thiết kế độc đáo và cứng cáp, được bao quanh bởi đèn LED matrix phía trước dạng hình chữ C. Miệng dưới rộng hơn tạo một diện mạo táo bạo hơn và đặc sắc hơn.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/wildtrak/wildtrak-col-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Mâm xe nổi bật
                            </Typography>
                            <Typography variant="body6">
                                Lốp bánh xe lớn của Wiltrak ôm trọn mâm xe hợp kim nhôm 18 inch màu Xám Boulder đầy ấn tượng.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/wildtrak/wildtrak-col-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng điều khiển công nghệ cao cấp
                            </Typography>
                            <Typography variant="body6">
                                Màn hình trung tâm hiện đại nhất trong phân khúc với kích thước 12 inch được bọc mềm và được thiết kế tinh gọn, chừa chỗ cho ngăn chứa đồ phía trước hành khách. Cùng với SYNC®4, màn hình giải trí LED cảm ứng 12 inch được tích hợp với mục đích mang đến trải nghiệm tiện nghi.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/wildtrak/wildtrak-col-4.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất hoàn thiện đặc trưng
                            </Typography>
                            <Typography variant="body6">
                                Với nội thất màu gỗ mun tuyệt đẹp, Wildtrak gợi lên nét độc đáo với đường chỉ màu cam Cyber, các điểm nhấn màu xám Boulder và các điểm tiếp xúc màu nhôm Satin cao cấp. Và không thể thiếu logo ‘Wildtrak’ đặc trưng màu cam Cyber trên ghế.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-ranger-sport': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/sport/sport-col-1.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Lưới tản nhiệt màu đen cá tính
                            </Typography>
                            <Typography variant="body6">
                                Các điểm nhấn tối màu hiện đại kết hợp với lưới tản nhiệt phía trước tối màu tạo nên vẻ ngoài thể thao hơn. Đèn pha LED dạng hình chữ C đậm chất Built Ford.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/sport/sport-col-2.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Vành hợp kim 18’’
                            </Typography>
                            <Typography variant="body6">
                                Mâm xe hợp kim 18 inch màu Đen Asphalt cùng lớp sơn hoàn thiện phủ mờ giúp tăng phần cá tính & thể thao.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/sport/sport-col-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng điều khiển trải rộng
                            </Typography>
                            <Typography variant="body6">
                                Bảng điều khiển trải rộng thiết kế kết nối với hệ thống cửa hai bên, tạo một không gian vô cùng rộng rãi cho khoang lái. Màn hình LCD giải trí trung tâm hiện đại với kích thước 10.1 inch.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/sport/cards/sport-card-04.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất hoàn thiện tối màu
                            </Typography>
                            <Typography variant="body6">
                                Nội thất sang trọng với các chi tiết hoàn thiện tối màu tạo nên sự vững chắc trong khoang lái.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-ranger-xls-plus': (
            <>
                <Box className={classes.boxList}>
                    <Typography variant="h1" className={classes.title1}>
                        Các tính năng nâng cấp
                    </Typography>
                </Box>
                <Grid container className={classes.gird4}>
                    <Grid item xs={12} md={6} >
                        <Box className={classes.contentChild}>
                            <Box height="100%" className={classes.boxImg4}>
                                <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/xls-plus/cards/drop-in-bed-liner.webp' />
                            </Box>
                            <Box className={classes.box1}>
                                <Typography variant="h1" className={classes.title1}>
                                    Lót thùng hàng
                                </Typography>
                                <Typography variant="body6">
                                    Ford Ranger XLS+ mới đáp ứng nhu cầu của các khách hàng muốn cá nhân hóa chiếc xe của mình để phù hợp với công việc, gia đình cũng như hoạt động giải trí hàng ngày. Bạn sẽ không còn lo lắng về phụ kiện không chính hãng hoặc vấn đề về đăng kiểm với Ranger XLS+ được lắp ráp trực tiếp ngay từ nhà máy, sẵn có với lựa chọn xe 4x2 và 4x4.
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6} >
                        <Box className={classes.contentChild}>
                            <Box height="100%" className={classes.boxImg4}>
                                <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/xls-plus/cards/roller-shutter-black.webp' />
                            </Box>
                            <Box className={classes.box1}>
                                <Typography variant="h1" className={classes.title1}>
                                    Nắp cuộn thùng hàng
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </>
        ),
        'ford-ranger-xls': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/xls/cards/xls-grille-iconic-silver.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Thiết kế đầu xe cứng cáp
                            </Typography>
                            <Typography variant="body6">
                                Lưới tản nhiệt màu đen mới kết hợp với đèn halogen dạng hình chữ C đặc trưng và đèn sương mù phía trước đậm chất Built Ford Tough.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/ranger/model/xls/cards/xls-wheels-iconic-silver.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                La zăng hợp kim
                            </Typography>
                            <Typography variant="body6">
                                Phiên bản Ranger XLS được trang bị mâm xe hợp kim nhôm 16 inch màu xám bạc có độ hoàn thiện cao.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/xls/xls-col-3.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Bảng điều khiển công nghệ liền mạch
                            </Typography>
                            <Typography variant="body6">
                                Thiết kế bảng điều khiển cùng màn hình giải trí trung tâm liền mạch giúp khoang xe trở nên rộng hơn, tạo cảm giác thoải mái và tiện nghi. Màn hình giải trí trung tâm công nghệ cao LED 10 inch được thiết kế hiện đại và mạnh mẽ.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/ecomm/mvp_dummyassets/vn/nameplate/next-gen-ranger/models/xls/xls-col-4.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Nội thất màu đen hoàn thiện
                            </Typography>
                            <Typography variant="body6">
                                Được thiết kế sử dụng các vật liệu tối màu có độ bền cao nhưng vẫn mang lại cảm giác thoải mái, phiên bản Ranger XLS mang lại phong cách thiết kế nội thất cứng cáp khỏe khoắn.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        ),
        'ford-mustang-mach-e-premium-awd': (
            <Grid container className={classes.gird4}>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/mustang-mach-e/models/premium-4wd/cards/impressive-performance.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Khả năng vận hành ấn tượng
                            </Typography>
                            <Typography variant="body6">
                                Cảm nhận khả năng tăng tốc tức thì của Mustang Mach-E, nhờ vào 4 động cơ điện, mang tới công suất tối đa 395PS và mô men xoắn 627Nm mô men xoắn.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/mustang-mach-e/models/premium-4wd/cards/operating-distance.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Khoảng cách vận hành 550Km
                            </Typography>
                            <Typography variant="body6">
                                Tự tin cầm lái chiếc Mustang Mach-E trên những cung đường dài và tận hưởng những hành trình đầy hứng khởi.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/mustang-mach-e/models/premium-4wd/cards/sports-alloy-rims.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Vành hợp kim thể thao​
                            </Typography>
                            <Typography variant="body6">
                               Ngoại hình khoẻ khoắn với thiết kế vành hợp kim 19” và cùm phanh màu đỏ giúp nổi bật thiết kế thể thao của xe.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Box className={classes.contentChild}>
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/vn/nameplate/mustang-mach-e/models/premium-4wd/cards/luxurious-interior.webp' />
                        </Box>
                        <Box className={classes.box1}>
                            <Typography variant="h1" className={classes.title1}>
                                Hoàn thiện và vật liệu sang trọng
                            </Typography>
                            <Typography variant="body6">
                                Bạn không chỉ đang lái một chiếc xe có thiết kế ngoại thất đẹp và đi cùng với đó là trải nghiệm di chuyển tiện nghi, sang trọng. Nội thất của Mach-E là mảnh ghép hoàn hảo cho lối sống và phong cách của bạn.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                
            </Grid>
        ),

    };
    return (
        <Box className={classes.root}>
            <Container maxWidth="lg">
                <Grid container className={classes.gird4}>
                    <Grid item xs={12} md={4} className={classes.gridParent}>
                        <Box >
                            <Box className={classes.box0}>
                                <Typography variant="h1" className={classes.title1}>
                                    {data.tendaydu}
                                </Typography>
                            </Box>
                            <Box className={classes.box1}>
                                <Typography variant="h6"  >
                                    {data.gia} VNĐ
                                </Typography>
                                <Typography variant="body2" >
                                    Giá niêm yết từ
                                </Typography>
                            </Box>
                            <Box className={classes.box1}>
                            {data.dongco && (
                                <>
                                <Typography variant="h6">{data.dongco}</Typography>
                                <Typography variant="body2">Động cơ</Typography>
                                </>
                            )}
                            </Box>
                            <Box>
                                <Button variant="contained" href={`/dang-ky-lai-thu/${name}`} className={classes.button} >
                                    Đăng ký lái thử
                                </Button>
                                <Button variant="outlined" href={`/bao-gia/${name}`} className={classes.button61}>
                                    Báo giá
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={8} >
                        <Box height="100%" className={classes.boxImg4} sx={{ pt: 3 }}>
                            <img className={classes.imageWeb} src={data.anhnoidung} />
                        </Box>
                    </Grid>
                </Grid>
                <Box className={classes.content}>
                    {componentMap[name]}
                    <Container maxWidth='md'>
                        <Box className={classes.boxList}>
                            <Typography variant="h1" className={classes.title1}>
                                Thông số kỹ thuật {data.tendaydu}
                            </Typography>
                        </Box>
                        <SimpleAccordion name={name} />
                    </Container>
                </Box>
            </Container>
        </Box>
    );
};

export default ChiTietXe;